import { useState } from 'react';
import * as style from '../../utils/general_style.js';
import * as links from '../../utils/general_links.js';
import NavButton from './NavButton.jsx';

function NavBar() {
    const [isOpen, setIsOpen] = useState(false);
    const toggling = () => {
        setIsOpen(!isOpen);
	};
	const closing = () => {
        setIsOpen(false);
	};

    const navBarData = [
        {
            name: 'Étude de sol',
            path: null,
            isOpen
        }, {
            name: 'Qui sommes-nous ?',
            path: links.ROUTES.quiSommesNous,
            isOpen
        }, {
            name: 'Espace pro',
            path: links.ROUTES.espacePro,
            isOpen
        }, {
            name: 'F.A.Q.',
            path: links.ROUTES.faq,
            isOpen
        }
    ];

	return (
        <div style={{width: '100%', backgroundColor: style.COLORS.secondary}}>
            <div style={{...style.ROW_SPACE_AROUND, height: '40px', maxWidth: '980px', margin: 'auto'}}>
                {navBarData.map((navButton, index) => (
                    <NavButton name={navButton.name} path={navButton.path} key={index} isOpen={navButton.isOpen} onClick={navButton.name === 'Étude de sol' ? toggling : closing}/>
                ))}
            </div>
        </div>
	);
};

export default NavBar;